import SentimentModal from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/SentimentModal/SentimentModal';
import { withSentimentalModalProps } from 'viewModel/productPage/ratingsAndReviews/sentimentModal/withSentimentModalProps';

export default withSentimentalModalProps(SentimentModal);
